import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getTrackSize, getTrackProgress } from '../../../helpers/Step.helpers.js';
import { useDirectionContext, Direction } from '../../../../../../contexts/session/Locale.js';
import { getHorizontalTrackPositionLeft, getHorizontalTrackPositionRight } from './HorizontalStep.helpers.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getStepContainerAlignment = function getStepContainerAlignment(stepAlignment) {
  if (stepAlignment === 'top') {
    return {
      mb: 'auto'
    };
  }
  if (stepAlignment === 'bottom') {
    return {
      mt: 'auto'
    };
  }
  return {};
};
var useHorizontalStepContainer = function useHorizontalStepContainer(stepAlignment) {
  return _objectSpread({
    as: 'li',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    px: '4',
    flex: 1
  }, getStepContainerAlignment(stepAlignment));
};
var useHorizontalStepTrackContainer = function useHorizontalStepTrackContainer(_ref) {
  var size = _ref.size;
  var direction = useDirectionContext();
  var left = getHorizontalTrackPositionLeft(size);
  var right = getHorizontalTrackPositionRight(size);
  return {
    display: 'flex',
    position: 'absolute',
    left: direction === Direction.LTR ? left : right,
    right: direction === Direction.LTR ? right : left
  };
};
var useHorizontalStepTrack = function useHorizontalStepTrack(_ref2) {
  var state = _ref2.state,
    size = _ref2.size;
  return {
    direction: 'horizontal',
    size: getTrackSize(size),
    progress: getTrackProgress('dynamic', state)
  };
};

export { useHorizontalStepContainer, useHorizontalStepTrack, useHorizontalStepTrackContainer };
//# sourceMappingURL=useHorizontalStep.js.map
